<!--SKU编辑  -->
<template>
	<div>
		<el-dialog title="角色信息" :visible.sync="dialogVisible" width="600px">
			<div class="form-box">
				<el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="80px">
					<el-form-item label="角色名称" prop="roleName">
						<el-input v-model.trim="dataForm.roleName" maxlength="15" :disabled="disable"></el-input>
					</el-form-item>
					<el-form-item label="数据权限" prop="permType">
						<el-select v-model="dataForm.permType" placeholder="请选择" :disabled="disable" class="width100">
							<el-option label="浏览" value="0"></el-option>
							<el-option label="编辑" value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="角色描述" prop="roleContent">
						<el-input v-model.trim="dataForm.roleContent" :disabled="disable" type="textarea" :rows="3" maxlength="100" resize="none"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" size="small" v-if="!disable" @click="handleRolePermissions">业务权限</el-button>
				<el-button type="primary" size="small" v-if="!disable" @click="handleSubmit">确 定</el-button>
			</span>
		</el-dialog>
		<permissions v-if="permissionsDialog" ref="permissions" @permissionsListener="permissionsListener">
		</permissions>
	</div>
</template>

<script>
	import { debounce } from '@/utils/debounce'
	import permissions from './role-permissions.vue';
	export default {
		components: {
			permissions
		},
		data() {
			return {
				dialogVisible: false,
				permissionsDialog: false,
				disable: false,
				dataForm: {
					roleName: '',
					permType: '',
					roleContent: '',
					mbCode: []
				},
				rules: {
					roleName: [
						{
							required: true,
							message: '请输入角色名称',
							trigger: 'blur'
						}
					],
					permType: [
						{
							required: true,
							message: '请选择数据权限',
							trigger: 'change'
						}
					],
				},
				halfKeys:[],
			}
		},
		methods: {
			init(id) {
				this.dialogVisible = true;
				this.$nextTick(() => {
					this.$refs.dataForm.resetFields();
					delete this.dataForm.id;
					this.dataForm.mbCode = [];
					this.disable = false;
					if(id) {
						this.dataForm.roleId = id;
						if(['1','2','3'].includes(id)){
							this.disable = true;
						}
						this.getRoleInfo();
					}
				})
			},
			//  业务权限
			handleRolePermissions() {
				this.permissionsDialog = true;
				this.$nextTick(() => {
					this.$refs.permissions.init(this.dataForm.mbCode);
				});
			},
			// 获取角色信息
			getRoleInfo() {
				let that = this;
				that.$request.post(
					"getRoleInfo",
					true,
					{
						roleId: that.dataForm.roleId
					}
				)
				.then((res) => {
					if (res) {
						that.dataForm.roleName = res.data.roleName;
						that.dataForm.permType = res.data.permType+'';
						that.dataForm.roleContent = res.data.roleContent;
						let mbCode = [];
						res.data.rolePrivileList.forEach(item => {
							mbCode.push(item.mbCode);
						})
						that.dataForm.mbCode = mbCode;
					}
				})
			},
			handleSubmit:debounce(function() {
				if(this.dialogVisible == false) {
					return
				}
				this.$refs['dataForm'].validate(valid => {
					if (valid) {
						this.$confirm('是否确认保存？', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
						}).then(() => {
						let that = this;
						that.dataForm.mbCode=that.dataForm.mbCode.concat(this.halfKeys)
						console.log(that.dataForm.mbCode)
						that.$request.post(
							that.dataForm.roleId ? 'updateRole' : 'addRole',
							true, that.dataForm
						)
						.then((res) => {
							if (res) {
								that.dialogVisible = false;
								that.$emit('getList');
								that.$message.success('保存成功');
							}
						})
						}).catch(() => {});
					} else {
						return false;
					}
				});
			},1000,true),
			// 业务权限回调
			permissionsListener(mbcode) {
				this.dataForm.mbCode = []
				this.dataForm.mbCode = mbcode.keys;
				this.halfKeys = []
				this.halfKeys = mbcode.halfkeys
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.mb0 {
		margin-bottom: 0 !important;
	}

	.el-button+.el-button {
		margin-left: 10px;
	}

</style>
